export const setLabels = 'SET_LABELS'
export const setLabelsRemote = 'SET_LABELS_REMOTE'
